<template>
  <div class="p-0 pt-5 mt-5 col-md-8 mx-auto">
    <v-row class="mt-5">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="title"
          label="عنوان تاریخچه"
          required
          dense
          outlined
          class="mt-1"
          prepend-inner-icon="fa fa-pencil-alt"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="step"
          label="مرحله"
          required
          dense
          outlined
          class="mt-1"
          prepend-inner-icon="fa fa-pencil-alt"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="12">
        <date-picker
          v-model="created_at"
          type="datetime"
          format="YYYY-MM-DD HH:mm"
          display-format="jYYYY-jMM-jDD HH:mm"
          :timezone="false"
          auto-submit
          label="زمان آخرین تماس"
          endTime
        ></date-picker>
      </v-col>

      <v-col cols="12" md="12">
        <p>مذاکرات انجام شده :</p>
        <suggest-text
          v-model="description"
          label="مذاکرات انجام شده :"
          rows="10"
        />

        <!-- <v-editor v-model="description"></v-editor> -->
      </v-col>
      <v-col cols="12" md="12">
        <date-picker
          v-model="time"
          type="datetime"
          format="YYYY-MM-DD HH:mm"
          display-format="jYYYY-jMM-jDD HH:mm"
          :timezone="false"
          auto-submit
          label="زمان یادآوری"
          endTime
        ></date-picker>
      </v-col>
      <v-col cols="12" md="12">
        <p>موارد پیگیری در تماس بعدی :</p>
        <suggest-text
          v-model="purpose"
          label="موارد پیگری در تماس بعدی"
          rows="10"
        />

        <!-- <v-editor v-model="purpose"></v-editor> -->
      </v-col>
    </v-row>
    <div class="row mr-auto">
      <v-btn :loading="loading" @click="submitForm" class="submit-btn">
        <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
        ثبت تاریخچه
      </v-btn>
    </div>
  </div>
</template>

<script>
import SuggestText from "@/view/components/SuggestBox/suggestInput.vue";
import "vue-persian-datetime-picker";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from "sweetalert2";

export default {
  name: "addHistory",
  props: {
    time: {
      default: "",
    },
    id: {
      default: "",
    },
    modal: {
      default: false,
    },
    reload: {
      type: Function,
    },
  },
  components: { SuggestText },
  data() {
    return {
      title: "",
      step: "",
      remind_date: "",
      created_at: "",
      description: "",
      purpose: "",
      NowTime: [],
      loading: false,
    };
  },
  methods: {
    submitForm() {
      this.loading = true;
      this.$api
        .post(`admin/qr/history`, {
          qr_id: this.id,
          title: this.title,
          step: this.step,
          remind_date: this.time,
          description: this.description,
          purpose: this.purpose,
        })
        .then(() => {
          this.loading = false;
          this.$toast.success("تاریخچه مورد نظر با موفقیت ثبت شد.");
          this.reload();
          this.modal();
        })
        .catch((err) => {
          this.loading = false;
          this.$modal.error(
            "خطا!",
            "",
            Object.keys(err.response.data.errors)
              .map((key) => {
                return err.response.data.errors[key][0];
              })
              .join("\n")
          );
        });
    },
  },
};
</script>

<style></style>
